import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

// -------------------- Development Error --------------------
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.other.DevelopmentError.';
  public static readonly developmentError_unexpected = `${Id.prefix}unexpected`;
}

export class LangDevelopmentError {
  private constructor() {}
  public static unexpected(message: string): string {
    return interpolate(Id.developmentError_unexpected, { message });
  }
}

export class DevelopmentErrorModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.developmentError_unexpected,
      'Unexpected Development Error\n{{message}}\n',
      'Error message for unexpected development error, with message.'
    );
  }
}
